// One WellSky rate vocabulary, shared by the assign modal and the v3 card.
import { type RateCategory } from '@libraries/typescript/api_client';

export function getRateCategoryDisplayName(rateCategory: RateCategory): string {
    return rateCategory.display_name ?? rateCategory.name;
}

// WellSky's payable rate types. A custom pay amount is valid only for these.
export const CUSTOM_CAREGIVER_RATE_TYPES = [
    { value: '1', label: 'Hourly' },
    { value: '2', label: 'Per Visit' },
    { value: '3', label: 'Live In' },
] as const;

export type CustomCaregiverRateType =
    (typeof CUSTOM_CAREGIVER_RATE_TYPES)[number]['value'];

const CUSTOM_CAREGIVER_RATE_AMOUNT_PATTERN =
    /^(?:0|[1-9]\d{0,3})(?:\.\d{1,2})?$/;
const MAX_CUSTOM_CAREGIVER_RATE_AMOUNT = 9999.99;

export function isValidCustomCaregiverRateAmount(
    amount: string | null | undefined,
): boolean {
    const trimmed = amount?.trim();
    if (!trimmed || !CUSTOM_CAREGIVER_RATE_AMOUNT_PATTERN.test(trimmed)) {
        return false;
    }
    const parsed = Number(trimmed);
    return parsed > 0 && parsed <= MAX_CUSTOM_CAREGIVER_RATE_AMOUNT;
}

export function toCustomCaregiverRateType(
    rateType: string | number | null | undefined,
): CustomCaregiverRateType | null {
    const value = String(rateType);
    return (
        CUSTOM_CAREGIVER_RATE_TYPES.find((type) => type.value === value)
            ?.value ?? null
    );
}
